<template>
<div >
  <section class="hero is-dark is-large">
    <!-- eslint-disable max-len -->
    <progressive-background
      class="background-image"
      src="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/BackgroundPhoto_v6.jpg?alt=media&token=64c69fd9-52b6-4925-a81e-6b2d26dd941c"
      placeholder="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/BackgroundPhoto_v6_small.png?alt=media&token=2796a154-5853-44a5-943d-7d7ef9421502"
      no-ratio
    />
    <div class="hero-body">
      <div class="container">
        <div class="logo">
          <Logo style="fill:white" class="logo-svg" />
        </div>
        <h2 class="subtitle has-text-centered">
          The natural kitchen <em>essential</em> for garlic lovers
        </h2>
        <div class="buy-button-container">
          <span class="buy-button is-white" v-on:click="toggleModal()">Get Yours Now!</span>
        </div>
      </div>
    </div>
  </section>
  <UpArrow />
  <section class="section" id="how-to">
    <div class="container">
      <h2 class="title has-text-centered">How To Use</h2>
      <TwoLines />
      <HowTo />
    </div>
  </section>
  <ArrowsDown color="#FFF" />
  <section class="section section-invert" id="why">
    <div class="container">
      <h2 class="title has-text-centered">Why A Rock?</h2>
      <TwoLines />
      <Why />
    </div>
  </section>
  <ArrowsDown color="hsl(0, 0%, 86%)"/>
  <section class="section" id="about">
    <div class="container">
      <h2 class="title has-text-centered">About Us</h2>
      <TwoLines />
      <About />
    </div>
  </section>
  <footer class="footer">
    <div>Brought to you by <strong>Terri Tutt Essentials, LLC</strong></div>
  </footer>
  <transition name="fade">
    <ShopifyModal v-show="isShopifyModalShown" v-on:show-shopify-modal="toggleModal" />
  </transition>
</div>
</template>

<script>
import Logo from '@/assets/garlic_rock_logo.svg';

const Why = () => import('@/components/Why');
const HowTo = () => import('@/components/HowTo');
const About = () => import('@/components/About');
const UpArrow = () => import('@/components/UpArrow');
const TwoLines = () => import('@/components/TwoLines');
const ArrowsDown = () => import('@/components/ArrowsDown');
const ShopifyModal = () => import('@/components/ShopifyModal');

export default {
  name: 'Landing',
  components: {
    Logo,
    Why,
    HowTo,
    About,
    UpArrow,
    TwoLines,
    ArrowsDown,
    ShopifyModal,
  },
  data() {
    return {
      Logo,
      isShopifyModalShown: false,
    };
  },
  methods: {
    toggleModal: function toggleModal() {
      this.isShopifyModalShown = !this.isShopifyModalShown;
    },
  },
};
</script>

<style lang="scss">
@import '../../static/_main';

h2 {
  margin-bottom: 1.5rem !important;
}

.background-image {
  position: absolute !important;
  z-index: 0;
  height: 100vh !important;
}

.subtitle {
  font-weight: 600;
  margin: 0 auto;
  padding: 1rem 0;
}

.hero,
.hero-body,
.background-image {
  min-height: 800px;
}

.hero {
  background-size: cover;
  height: 100vh;
}

.hero-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
}

.logo {
  max-width: 800px;
  margin: 0 auto;
}

.logo-svg {
  max-height: 50vh;
}

.section-invert {
  background-color: $white;
}

.footer {
  background-color: $black !important;
  color: $white;
  strong {
    color: $white;
  }
}

.buy-button-container {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.buy-button {
  font-family: $family-secondary;
  cursor: pointer;
  padding: 0.5rem 2rem;
  text-transform: uppercase;
  color: #fff !important;
  background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  animation: Gradient 15s ease infinite;
  border: 3px solid transparent !important;
  border-radius: 120px;
  font-weight: 600;
  transition: 200ms border ease-in;
  &:hover,
  &:focus {
    color: $white !important;
    border: 3px solid white !important;
  }
}

@media (max-width: $tablet) {
  .hero,
  .hero-body,
  .background-image {
    height: 100vh;
    max-height: 800px;
  }

  .footer {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Landing.vue